import React from "react";
import { FiSettings } from "react-icons/fi";
import { AiOutlinePlus } from "react-icons/ai";
import { Link } from "react-router-dom";
import { BiChevronRight } from "react-icons/bi";
import { BiChevronLeft } from "react-icons/bi";
import LanguageTable from "./languageTable/LanguageTable";
import { Pagination } from "antd";

function ListLanguage({ data, getLanguageData, onChangeVal, initialVlue, handleChange, reset }) {
  // console.log(data);

  return (
    <>
      <div className="pageTableWrapper">
        <div className="pageHeader">
          <div className="pageTitle">
            <FiSettings />
            <h5>LANGUAGES</h5>
          </div>
          <div className="addNew">
            <Link to="/admin/create-language" className="btn btn-success">
              <AiOutlinePlus /> Add New Language
            </Link>
          </div>
        </div>

        <div className="pageBody">
          <LanguageTable data={data} getLanguageData={getLanguageData} initialVlue={initialVlue} handleChange={handleChange} reset={reset} />
        </div>

        <div className="pageFooter">
          <div className="row">
            <div className="col-md-6">
              <div className="showEntry">
                <p>Showing {data?.totalCount} entries</p>
              </div>
            </div>
            <div className="col-md-6">
              <Pagination
                defaultCurrent={1}
                onChange={onChangeVal}
                total={data?.totalCount}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default ListLanguage;
